// SuspenseFallback.tsx
const SuspenseFallback = () => null;

export default SuspenseFallback;